/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Detail_Open_Application_ButtonInputs */

const en_admin_user_detail_open_application_button = /** @type {(inputs: Admin_User_Detail_Open_Application_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open application`)
};

const de_admin_user_detail_open_application_button = /** @type {(inputs: Admin_User_Detail_Open_Application_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbung öffnen`)
};

/**
* | output |
* | --- |
* | "Open application" |
*
* @param {Admin_User_Detail_Open_Application_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_detail_open_application_button = /** @type {((inputs?: Admin_User_Detail_Open_Application_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Detail_Open_Application_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_detail_open_application_button(inputs)
	return en_admin_user_detail_open_application_button(inputs)
});